import React from "react";

import Image from "next/image";
import Link from "next/link";

import { Box, Link as MuiLink } from "@mui/material";

import LogoImage from "../../public/static/logo.png";

const Logo = ({ sx, ...props }) => (
  <Box sx={{ height: 48, width: 133.33, ...sx }} {...props}>
    <Link href="/" passHref>
      <MuiLink sx={{ lineHeight: 1 }}>
        <Image
          alt="飛天奶茶"
          height={48}
          width={133.33}
          src={LogoImage}
          priority
        />
      </MuiLink>
    </Link>
  </Box>
);

export default Logo;
